import React from 'react';

//helpers
import {styleable} from 'decorators';

//components
import {FormattedMessage} from 'components/FormattedComponents';
import {HeadingDesktop, HeadingMobile} from 'components/Heading';
import {TextDesktop, TextMobile} from 'components/Text';

import {INSTRUCTION_TYPE} from 'enums';

//styled-components
import {
  Chevron,
  ContentWrapper,
  StyledCloudinaryPicture,
  InstructionRowLink,
  InstructionRowStatic,
  HeadingWrapper,
  ChecklistIcon
} from './styles';

//messages
import messages from './messages';

const InstructionRowBase = styleable(
  ({device, id, instruction, params, queryParams, shouldShowSpinnerWhileLoading = false, store, route}) => {
    const {imageUrl, stepsNumber, title, type} = instruction;
    const isLink = store && store.router && route;
    const isMobile = device === 'mobile';

    const InstructionRow = isLink ? InstructionRowLink : InstructionRowStatic;
    const Heading = isMobile ? HeadingMobile : HeadingDesktop;
    const Text = isMobile ? TextMobile : TextDesktop;

    const metadata = instruction.metadata
      ? instruction.metadata
      : instruction.media && instruction.media.metadata
      ? instruction.media.metadata
      : {};
    const isChecklist = type === INSTRUCTION_TYPE.CHECKLIST;
    const entityMessage = isChecklist ? messages.x_checks : messages.x_steps;
    const dataCyHeading = isChecklist ? 'checklist-title' : 'instruction-title';
    const dataCyRow = isChecklist ? 'checklist-card' : 'instruction-card';
    const dataCyEntityNumber = isChecklist ? 'checks-number' : 'steps-number';

    return (
      <InstructionRow
        id={id}
        store={store}
        route={route}
        params={params}
        queryParams={queryParams}
        isLink={isLink}
        device={device}
        dataCy={dataCyRow}
      >
        <StyledCloudinaryPicture
          metadata={metadata}
          shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
          shouldShowOverlayShapes
          src={imageUrl}
        />
        <ContentWrapper>
          <HeadingWrapper data-cy={`${dataCyHeading}-${title.split(' ').join('-')}`}>
            {isChecklist && <ChecklistIcon />}
            <Heading maxLines={1} size="xsmall" data-cy={dataCyHeading}>
              {title}
            </Heading>
          </HeadingWrapper>
          <Text secondary data-cy={dataCyEntityNumber}>
            <FormattedMessage {...entityMessage} values={{stepCount: stepsNumber, checkCount: stepsNumber}} />
          </Text>
        </ContentWrapper>
        {isMobile && <Chevron />}
      </InstructionRow>
    );
  }
);

export const InstructionRowDesktop = props => <InstructionRowBase device="desktop" {...props} />;

export const InstructionRowMobile = props => <InstructionRowBase device="mobile" {...props} />;
